"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ark = require("@dateam/ark");
var _arkReact = require("@dateam/ark-react");
var _dropdownMenu = _interopRequireDefault(require("../../dropdownMenu"));
const MultiselectOption = _ref => {
  let {
    id,
    className,
    value,
    children,
    checked,
    onChange
  } = _ref;
  const textValue = _react.default.useMemo(() => {
    return (0, _ark.isDefined)(value) ? value.toString() : undefined;
  }, [value]);
  const onCheckboxChange = event => {
    const newValue = event.target.checked === true;
    if ((0, _ark.isFunction)(onChange)) onChange(value, newValue, event);
  };
  const handleClick = () => {
    const newValue = checked !== true;
    if ((0, _ark.isFunction)(onChange)) onChange(value, newValue, event);
  };
  const itemId = (0, _ark.isString)(id) ? `${id}_${textValue}` : undefined;
  return /*#__PURE__*/_react.default.createElement(_dropdownMenu.default.Item, {
    id: id,
    className: "multiselectItem",
    onClick: handleClick
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _arkReact.concatClassName)('formCheck multiselect-check', checked ? 'formCheck-checked' : null)
  }, /*#__PURE__*/_react.default.createElement("input", {
    id: itemId,
    type: "checkbox",
    className: "checkbox",
    onChange: onCheckboxChange,
    checked: checked ?? false
  })), /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: itemId,
    className: "multiselect-label",
    onClick: event => event.stopPropagation()
  }, children));
};
process.env.NODE_ENV !== "production" ? MultiselectOption.propTypes = {
  id: _propTypes.default.string,
  className: _propTypes.default.string,
  value: _propTypes.default.any,
  children: _propTypes.default.node,
  checked: _propTypes.default.bool,
  onChange: _propTypes.default.func
} : void 0;
MultiselectOption.defaultProps = {
  id: undefined,
  className: undefined,
  value: undefined,
  children: undefined,
  checked: false,
  onChange: undefined
};
var _default = exports.default = MultiselectOption;